export const tr = {
    'add-button': 'Ekle',
    'exclude-phrases': 'Sıfır göstergeli sözcük gruplarını hariç tut',
    placeholder: 'Lütfen, anahtar sözcük gruplarını aralarına virgül veya " | " operatörü ekleyerek ekleyin'
};
